import { NgTemplateOutlet, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WellIntergrityManagementService } from '../../service/well-intergrity-management.service';
import { ImageViewerDialogComponent } from 'app/core/shared/component/image-viewer-dialog/image-viewer-dialog.component';
import { ImageViewer } from 'app/core/shared/component/image-viewer-dialog/image-viewer-dialog.model';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'well-remarks',
  templateUrl: './well-remarks.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet, CommonModule, MatIconModule, MatTooltipModule],

  styleUrls: ['./well-remarks.component.scss']
})
export class WellRemarksComponent {
  @Input() data: any;  // Default value

  constructor(
    private dialog: MatDialog,
    private readonly service: WellIntergrityManagementService,
  ) { }

  async view(e, index: number) {
    e.stopPropagation();
    e.preventDefault();

    const images = [];
    const blobImages = [];

    const attachment = this.data.attachments;

    // handle image file
    for (const key in attachment) {
      const row = attachment[key];

      if (row.id) {
        this.service.getWipRemarkAttchmentById(row.id).subscribe((value) => {
          const url = window.URL.createObjectURL(value);
          blobImages.push(url);
          images.push(url);
        });
      }
    }

    // return images;
    const data: ImageViewer = {
      current: 0,
      images,
      blobImages,
    };

    this.dialog.open(ImageViewerDialogComponent, {
      data,
      width: '70%',
      panelClass: 'transparent-dialog',
    });
  }
}
